import './lohn.css';
import { Navigate, Route, Routes, useParams } from 'react-router-dom';
import { RequestSheetHost } from '../anfragen/RequestSheet';
import { useClientApp } from '../context';
import { lohnPath } from './labels';
import { NewEmployeePage } from './NewEmployee';
import { EmployeeSheetHost, FirmPage, FirmsPage, MonthPage } from './Pages';

// Alle Seiten unter /app/mitarbeiter: Firma → Mitarbeiter und Lohnunterlagen; Mitarbeiter anlegen; Lohn eines Monats.
export function LohnRoutes() {
  return (
    <Routes>
      <Route index element={<FirmsPage />} />
      <Route path=":clientId" element={<Level />} />
      <Route path=":clientId/neu" element={<Level page="neu" />} />
      <Route path=":clientId/lohn/:year/:month" element={<Level page="monat" />} />
      <Route path="*" element={<Navigate to={lohnPath()} replace />} />
    </Routes>
  );
}

// Prüft die Teile der Adresse und zeigt die passende Seite
function Level({ page }: { page?: 'neu' | 'monat' }) {
  const { clients } = useClientApp();
  const p = useParams();
  const clientId = p.clientId ?? '';
  if (!clients.some((c) => c.id === clientId)) return <Navigate to={lohnPath()} replace />;
  if (page === 'neu') return <NewEmployeePage clientId={clientId} />;
  if (page === 'monat') {
    const year = Number(p.year);
    const month = Number(p.month);
    if (!Number.isInteger(year) || year < 2000 || year > 2100 || !Number.isInteger(month) || month < 1 || month > 12) {
      return <Navigate to={lohnPath(clientId)} replace />;
    }
    return <MonthPage clientId={clientId} year={year} month={month} />;
  }
  return (
    <>
      <FirmPage clientId={clientId} />
      <EmployeeSheetHost />
      <RequestSheetHost />
    </>
  );
}
